import script from "./yikedaOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./yikedaOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./yikedaOrderRecord.vue?vue&type=style&index=0&id=4317693f&lang=scss"

const __exports__ = script;

export default __exports__